var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"ui-checkbox"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('span',{staticClass:"check"},[_c('Icon',{staticClass:"icon",attrs:{"name":"check"}})],1),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.labelText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }